// extracted by mini-css-extract-plugin
module.exports = {"Price":"Price_Price__W6lrs","Price__Montyly":"Price_Price__Montyly__i1Uzp","Price__Emphasis":"Price_Price__Emphasis__34xNq"};